import React, { useRef, useImperativeHandle } from 'react'

const StripeInput = React.forwardRef(({ component: Component, ...other }, ref) => {
  const elementRef = useRef()

  useImperativeHandle(ref, () => ({
    focus: () => elementRef.current.focus(),
  }))

  return <Component onReady={element => (elementRef.current = element)} {...other} />
})

StripeInput.displayName = 'StripeInput'

export default StripeInput
